export const FILE_CONFIG = [
  {
    name: 'Wire List',
    key: 'wire_export_file',
  },
  {
    name: 'Signal',
    key: 'signal_export_file',
  },
  //   {
  //     name: 'Inline Connectors',
  //     key: 'inline_connector_export_file',
  //   },
  {
    name: 'Harness Description',
    key: 'harness_description_export_file',
  },
  {
    name: 'Connector',
    key: 'connector_export_file',
  },
]
